// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__3SJU3","link":"styles_link__xe3MP","card":"styles_card__1iC9j"};